import './App.css';
import SortVisualizer from './components/sortVisualizer';

function App() {
  return (
    <div className="App">
      <SortVisualizer></SortVisualizer>
    </div>
  );
}

export default App;
